import React from 'react';
import './about.css';
import Info from './Info';

const About: React.FC = () => {
  return (
    <section className="about section" id="about">
      <div className="section__header">
        <h2 className="section__title">About Me</h2>
        <span className="section__subtitle">My professional journey</span>
      </div>

      <div className="about__container container">
        <div className="about__data">
          <Info />

          <div className="about__content">
            <p className="about__description">
              Outside of coding, I enjoy mentoring, being active in tech communities like ColorStack and NSBE, and learning to play pickleball.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 
